import { z } from 'zod';
import { expectType } from './model.js';
import { EmptyPostBase, zFullPostBase, zPostBase } from './post.js';
export const zBusinessPostFields = z.object({
    postType: z.literal('businessPost'),
    businessId: z.string()
});
export const zBusinessPost = zPostBase.merge(zBusinessPostFields);
expectType({});
expectType({});
export const zFullBusinessPost = zFullPostBase.merge(zBusinessPostFields);
expectType({});
expectType({});
export const EmptyBusinessPost = {
    ...EmptyPostBase,
    postType: 'businessPost',
    businessId: ''
};
